import React from 'react'
import BoardStore from '../../flux/boards/BoardStore'

/**
 * Props passed to the baord name component
 */
export interface IBoardNameProps {
    boardId: number
}

/**
 * Simple component which renders the name of a board
 * @param props Properties
 */
function BoardNameComponent(props: IBoardNameProps) {
    const board = BoardStore.getBoard(props.boardId)

    return <>{board.name}</>
}

export { BoardNameComponent as default }
